import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { supabase } from '../lib/supabase'
import './Auth.css'

export default function ActualizarPassword({ onListo }) {
  const [password, setPassword] = useState('')
  const [confirmar, setConfirmar] = useState('')
  const [mostrarPassword, setMostrarPassword] = useState(false)
  const [mostrarConfirmar, setMostrarConfirmar] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleActualizar = async () => {
    if (password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return }
    if (password !== confirmar) { setError('Las contraseñas no coinciden'); return }
    setLoading(true); setError('')

    const { data, error } = await supabase.auth.updateUser({ password })
    if (error) { setError('No se pudo actualizar la contraseña. Pedí un nuevo link e intentá de nuevo.'); setLoading(false); return }

    onListo(data.user)
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-titulo">Nueva contraseña</h1>
        <p className="auth-subtitulo">Elegí una contraseña nueva para tu cuenta</p>

        <div className="auth-form">
          <div className="auth-campo">
            <label>Contraseña nueva</label>
            <div className="auth-campo-password">
              <input
                type={mostrarPassword ? 'text' : 'password'}
                placeholder="Mínimo 6 caracteres"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <button type="button" className="auth-toggle-password" onClick={() => setMostrarPassword(v => !v)}
                aria-label={mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'} tabIndex={-1}>
                {mostrarPassword ? <EyeOff size={18} strokeWidth={1.8} /> : <Eye size={18} strokeWidth={1.8} />}
              </button>
            </div>
          </div>

          <div className="auth-campo">
            <label>Confirmar contraseña</label>
            <div className="auth-campo-password">
              <input
                type={mostrarConfirmar ? 'text' : 'password'}
                placeholder="Repetí la contraseña"
                value={confirmar}
                onChange={e => setConfirmar(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleActualizar()}
              />
              <button type="button" className="auth-toggle-password" onClick={() => setMostrarConfirmar(v => !v)}
                aria-label={mostrarConfirmar ? 'Ocultar contraseña' : 'Mostrar contraseña'} tabIndex={-1}>
                {mostrarConfirmar ? <EyeOff size={18} strokeWidth={1.8} /> : <Eye size={18} strokeWidth={1.8} />}
              </button>
            </div>
          </div>

          {error && <p className="auth-error">{error}</p>}

          <button className="auth-btn" onClick={handleActualizar} disabled={loading}>
            {loading ? 'Actualizando...' : 'Actualizar contraseña'}
          </button>
        </div>
      </div>
    </div>
  )
}
